import PropTypes from "prop-types";
import React from "react";
import { Box, Flex, useMantineTheme } from "@mantine/core";
import { Title, Text, Container, Image } from "@mantine/core";
import { useStylesPage } from "../utils/mantine/useStylesPage";

const CollectionNotFound = ({ staticBasePath, errorMessage }) => {
  // Mantine theme instance to apply custom styles and theming throughout the component
  const theme = useMantineTheme();
  const { classes: classesPage } = useStylesPage();
  return (
    <>
      <Flex
        align={theme.flex.align.center}
        direction="column"
        className={classesPage.pageCollectionFound}
      >
        <Box className="header-wrap">
          <Container size="sm" pt="lg">
            {errorMessage && (
              <>
                <Image
                  src={`${staticBasePath}public/images/svg/not_validate.svg`}
                  alt="Archive Cannot be Validated"
                  className={classesPage.pageHeaderIcon}
                />
                <Title order={1}>Collection Not Found</Title>
                <Text
                  className="errorCollectionFoundText"
                  size="lg"
                  styles={() => ({
                    root: {
                      color: theme.customColors.red,
                    },
                  })}
                >
                  {errorMessage}
                </Text>
              </>
            )}
          </Container>
        </Box>
      </Flex>
    </>
  );
};

CollectionNotFound.propTypes = {
  staticBasePath: PropTypes.string.isRequired,
  errorMessage: PropTypes.string.isRequired,
};
export default CollectionNotFound;
